/* This file was automatically generated - please modify the template not this file! */

import { ApplicationState } from "../../applicationState";
import { ADMIN_ROLES } from "../../auth";

import { customerCategorySelector } from "./selectors";

const detailRoute = () => ({
    "/:customerCategoryId": {
        title: (state: ApplicationState) => customerCategorySelector(state).name || "Customer Category",
        "/edit": {
            title: "Edit"
        }
    }
});

export const routes = {
    "/customerCategories": {
        authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        title: "Customer Categories",
        ...detailRoute(),
        "/create": {
            title: "Create Customer Category "
        }
    }
};
